import Pair from './Pair';
import Question from './Question';
import Sliderbar from './Sliderbar';
import Header from './Header';
import End from './End';
import PageNotFound from './PageNotFound';
import Interview from './Interview';

export { Pair, Question, Sliderbar, Header, End, PageNotFound, Interview };



// WEBPACK FOOTER //
// ./src/comparison-new/components/index.js